'use strict';

var chunkQ6JJKGDG_js = require('./chunk-Q6JJKGDG.js');
var chunk5WVHVQDL_js = require('./chunk-5WVHVQDL.js');
var chunkHUKGHOBJ_js = require('./chunk-HUKGHOBJ.js');
var t = require('react');
var s = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var t__default = /*#__PURE__*/_interopDefault(t);
var s__default = /*#__PURE__*/_interopDefault(s);

var U=s__default.default.span`
  display: inline-block;
  width: fit-content;
  font-size: ${({$fontSize:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  color: ${({$color:e})=>e};
  font-weight: ${({$fontWeight:e})=>e};
  ${({$borderColor:e,$borderd:n})=>{if(n)return `
        border-right: 1px solid ${e};
      `}}
  ${({$prefixBgColor:e,$height:n})=>{if(e)return `
        display: flex;
        justify-content: center;
        align-items: center;
        background: ${e};
        height: ${n};
        width: 64px;
      `}}
`,X=s__default.default.div`
  display: flex;
  flex-direction: column;
  gap: ${({$gap:e})=>e};
`,Y=s__default.default.div`
  height: ${({$height:e})=>e};
  border-radius: ${({$conrnerRadius:e})=>e};
  background-color: ${({$backgroundColor:e})=>e};
  border: 2px solid;
  display: flex;
  gap: ${({$gap:e})=>e};
  overflow: hidden;
  padding: ${({$padding:e})=>e};
  align-items: center;
  justify-content: space-between;

  ${({$isActive:e,$isError:n,$errorBorderColor:l,$activeBorderColor:a,$borderColor:h,$disabled:d,$disabledBorderColor:c})=>d?`
        border-color: ${c};
      `:e?`
        border-color: ${a};
      `:n?`
        border-color: ${l};
      `:`
      border-color: ${h};
    `}
`,k=s__default.default.div`
  font-size: ${({$fontSize:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  color: ${({$color:e})=>e};
`,Z=s__default.default.input`
  outline: none;
  border: none;

  height: 100%;
  width: 100%;
  flex: 1;
  font-size: ${({$fontSize:e})=>e};
  font-weight: ${({$fontWeight:e})=>e};
  line-height: ${({$lineHeight:e})=>e};
  color: ${({$color:e})=>e};
  background-color: transparent;
  caret-color: ${({$caretColor:e})=>e};
  padding: ${({$padding:e})=>e};
  text-transform: ${({$transformValue:e})=>e};
  transition: transform 0.2s;


  &::placeholder {
    color: ${({$placeholderColor:e})=>e};
  }

  &:focus,
  &:active {
    outline: none;
    border: none;
    transform: scale(0.98);
  }

  &:disabled {
    color: ${({$disabledColor:e})=>e};
  }
`,ie=t.forwardRef((e,n)=>{let{type:l="text",onChange:a,value:h,validator:d,hint:c,customErrorMessage:f="",allowClear:F=!1,onClear:b=()=>{},placeholder:_="",prefix:S,onFocus:p,onBlur:u,disabled:C=!1,onCopy:w,onCut:B,onPaste:L,suffix:I,validateOnChange:T=!1,isError:$=!1,transformValue:W="",autoFocus:O=!1}=e,{tokens:r}=chunkHUKGHOBJ_js.b(),o=chunkQ6JJKGDG_js.a(r),[y,H]=t.useState($),[V,j]=t.useState(f),[g,x]=t.useState(!1);t.useEffect(()=>{f&&j(f);},[f]);let A=i=>{let J=T&&typeof d=="function";i.target.value&&J&&!d(i.target.value)?H(!0):H(!1),typeof a=="function"&&a(i);},R=()=>{C||typeof b=="function"&&b();},q=i=>{typeof u=="function"&&(u==null||u(i)),x(!1);},D=i=>{typeof p=="function"&&(p==null||p(i)),x(!0);},G=t.useMemo(()=>!g&&t__default.default.isValidElement(I)?I:null,[g]);return t__default.default.createElement(X,{$gap:o.gap},t__default.default.createElement(Y,{$isActive:g,$isError:y||$,$activeBorderColor:o.activeBorderColor,$borderColor:o.borderColor,$conrnerRadius:o.cornerRadiusTokens,$errorBorderColor:o.errorBorderColor,$gap:o.gap,$height:r.size_58,$padding:`${r.spacing_10} ${r.spacing_12} ${r.spacing_10} ${r.spacing_0}`,$disabled:C,$disabledBorderColor:o.disabledBorderColor,$backgroundColor:r.background_fill_default_fill_primary},S&&t__default.default.createElement(U,{$fontSize:o.fontSize,$lineHeight:o.lineHeight,$borderd:!1,$borderColor:o.prefixBorderColor,$color:o.prefixColor,$fontWeight:o.prefixFontWeight,$prefixBgColor:l==="phone"?o.prefixBgColor:"",$height:r.size_58},S),t__default.default.createElement(Z,{type:chunkQ6JJKGDG_js.c[l],value:h,ref:n,onChange:A,placeholder:_||chunkQ6JJKGDG_js.b[l],onFocus:D,onBlur:q,$color:o.color,$fontSize:o.fontSize,$lineHeight:o.lineHeight,$placeholderColor:o.placeholderColor,disabled:C,$disabledColor:o.disabledColor,onCopy:w,onPaste:L,onCut:B,autoFocus:O,$caretColor:o.caretColor,$fontWeight:o.fontWeight,$padding:o.inputPadding,$transformValue:W}),F&&g&&t__default.default.createElement(chunk5WVHVQDL_js.a,{fill:o.iconColor,onClick:R}),G),c&&!y&&!$&&t__default.default.createElement(k,{$color:o.placeholderColor,$fontSize:o.errorFontSize,$lineHeight:o.errorLineHeight},c),(y||$)&&t__default.default.createElement(k,{$color:o.errorColor,$fontSize:o.errorFontSize,$lineHeight:o.errorLineHeight},V))});

exports.a = ie;
